module.exports = __webpack_public_path__ + "media/images/application/default/default-education-a9baf7e3f5bed57e79c1f3d839f7790e.jpg";